import React from 'react';

interface LayoutProps {
  children: React.ReactNode;
  title?: string;
}

export default function Layout({ children, title }: LayoutProps) {
  // Update document title if provided
  React.useEffect(() => {
    if (title) {
      document.title = title;
    }
    return () => {
      document.title = 'DocuTalk';
    };
  }, [title]);

  return (
    <div className="w-full">
      {children}
    </div>
  );
}